import React from "react";
import { Link } from "react-router-dom";
import { PageHero, Section } from "@/components/Editorial";

export default function NotFoundPage() {
  return (
    <div data-testid="not-found-page" className="bg-[#F7F1E7] min-h-[60vh]">
      <PageHero eyebrow="404" title="This page could not be found." lede="The address may have changed, or the page may not exist." />
      <Section className="pt-0">
        <Link to="/" data-testid="notfound-home-link" className="text-[11px] uppercase tracking-[0.2em] text-[#4B0F1E] border-b border-[#C7A45D] pb-1">
          Return home →
        </Link>
      </Section>
    </div>
  );
}
